import { ENGT_CHAT } from 'js/bot.model';
import './popup.scss';

const PopupTemplate = () => {
	const isSourcePreviewEnabled =
		ENGT_CHAT.get('config.isWebLinkPreviewEnabled') || ENGT_CHAT.get('config.isPdfLinkPreviewEnabled');

	/* html */
	const html = `
		<div class="engt-pages">
			<engt-header></engt-header>
	    	<launch-screen></launch-screen>
	    	<chat-screen></chat-screen>
		</div>
		<chat-settings></chat-settings>
		<upload-file-attachment></upload-file-attachment>
		<close-chat-modal></close-chat-modal>
		${isSourcePreviewEnabled ? '<source-preview></source-preview>' : ''}
    `;

	return html;
};

export default PopupTemplate;
